module.exports = __webpack_public_path__ + "static/media/About-us-background-image.03bee876.jpg";